export const refs = {
    countriesContainer: document.querySelector('.js-countries__wrapper'),
    countriesList: document.querySelector('.js-countries__list'),
    searchInput: document.querySelector('.js-input'),
    flagOverlay: document.querySelector('.js-flag__overlay'),
};
